import { Vertical } from "@/components/standard/BFLayout"
import { Pressable, View } from "react-native"
import { Button } from "@/components/reusables/ui/button"
import { Body, H2, H5 } from "@/components/standard/BFText"
import { useCallback, useEffect, useRef } from "react"
import {
  BottomSheetBackdrop,
  type BottomSheetBackdropProps,
  BottomSheetModal,
  BottomSheetView,
} from "@gorhom/bottom-sheet"
import { BFColors } from "@/constants/Colors"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import CloseIcon from "@/assets/icons/close-button.svg"

export const LoanArchivePopover = ({
  visible,
  onClose,
  onArchive,
}: {
  visible: boolean
  onClose: () => void
  onArchive: () => void
}) => {
  const bottomSheetModalRef = useRef<BottomSheetModal>(null)
  const insets = useSafeAreaInsets()

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => (
      <BottomSheetBackdrop
        {...props}
        appearsOnIndex={0}
        disappearsOnIndex={-1}
        onPress={() => {
          onClose()
        }}
      />
    ),
    [onClose]
  )

  useEffect(() => {
    if (!visible) {
      bottomSheetModalRef.current?.dismiss()
    } else {
      bottomSheetModalRef.current?.present()
    }
  }, [visible])

  return (
    <BottomSheetModal
      ref={bottomSheetModalRef}
      backdropComponent={renderBackdrop}
      backgroundStyle={{ backgroundColor: "#FFFFFF" }}
      handleIndicatorStyle={{ backgroundColor: BFColors.offWhite }}
      enableDynamicSizing={true}
    >
      <BottomSheetView>
        <Vertical
          className="pb-6 px-5"
          style={{ paddingBottom: Math.max(insets.bottom, 24) }}
        >
          <View className="items-end pt-4 pb-2 mb-8 mr-2">
            <Pressable
              testID="close-popover-button"
              hitSlop={16}
              onPress={onClose}
            >
              <CloseIcon width={14} height={14} color={BFColors.midnightBlue} />
            </Pressable>
          </View>

          <H2 className="text-center mb-2" color="primary">
            Don&apos;t need this quote?
          </H2>

          <Body className="text-center mb-6" color="primary">
            Archiving will remove this deal from your drafts, but you can always
            start a new one later.
          </Body>

          <Button
            variant="reverseDestructive"
            onPress={() => {
              bottomSheetModalRef.current?.dismiss()
              onArchive()
            }}
            className="mb-4"
          >
            <H5 className="color-red">Archive Quote</H5>
          </Button>

          <Pressable
            testID="back-to-quote-button"
            className="py-2 items-center justify-center"
            onPress={onClose}
          >
            <Body className="underline font-figtree-bold" color="primaryLight">
              Back to Quote Request
            </Body>
          </Pressable>
        </Vertical>
      </BottomSheetView>
    </BottomSheetModal>
  )
}
